function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.94,179.879c0.002,0.377,0.06,0.743,0.06,1.121c0,115.796-100.928,210-225,210h-63.832   c26.71,70.695,98.853,121,183.832,121h181c6.167,0,11.704-3.779,13.96-9.521s0.762-12.275-3.765-16.479l-41.03-38.057   C495.843,415.525,512,373.905,512,331C512,268.843,475.922,212.476,420.94,179.879z",
    fill: "#4b9bf5",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.805,334.999c-4.526,4.204-6.021,10.737-3.765,16.479S8.833,361,15,361h181c107.52,0,195-80.742,195-180S303.52,0,196,0   S0,81.742,0,181c0,42.905,16.157,83.525,45.835,115.942L4.805,334.999z M106,91h180c8.291,0,15,6.709,15,15s-6.709,15-15,15H106   c-8.291,0-15-6.709-15-15S97.709,91,106,91z M106,151h180c8.291,0,15,6.709,15,15s-6.709,15-15,15H106c-8.291,0-15-6.709-15-15   S97.709,151,106,151z M106,211h180c8.291,0,15,6.709,15,15s-6.709,15-15,15H106c-8.291,0-15-6.709-15-15S97.709,211,106,211z",
    fill: "#4b9bf5",
    "data-original": "#000000",
    style: {},
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.5ddad340176af3f702f6fc3178f7e126.svg";
export { ForwardRef as ReactComponent };